import { render } from "./dialogTableList.vue?vue&type=template&id=5901f8bd&scoped=true"
import script from "./dialogTableList.vue?vue&type=script&lang=js"
export * from "./dialogTableList.vue?vue&type=script&lang=js"

import "./dialogTableList.vue?vue&type=style&index=0&id=5901f8bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5901f8bd"]])

export default __exports__